export default __webpack_public_path__ + "static/media/chats.7053af61.svg";